import {dbComun} from '../bases-datos'

export const ObtenerAliadoPorId = async (id) => {
  return Promise.resolve(dbComun.table('Aliados').get({Id: id}))
}
